import React from "react";

import { BrowserRouter, Redirect, Route, Switch } from "react-router-dom";
import Splash from "../components/Splash";
import PasswordForgetPage from "../components/PasswordForget";
// HOME / POSTS
import HomeContainer from "../containers/HomeContainer";
import MyPostsContainer from "../containers/MyPostsContainer";
import NewPostApprovalContainer from "../containers/NewPostApproval";
import NewPostsContainer from "../containers/NewPostContainer";
import PostDetailsContainer from "../containers/PostDetails";
// CHAT
import ChatContainer from "../containers/ChatContainer";
import ChatRoomContainer from "../containers/ChatRoom";
import NewChatContainer from "../containers/ChatContainer/NewChat";
// LEAVES
import AirportContainer from "../containers/AirportContainer";
import NewLeave from "../containers/NewLeave";
import LeaveDetails from "../containers/LeaveDetails";
// PROFILES
import MyProfile from "../containers/MyProfile";
import ProfileContainer from "../containers/ProfileContainer";
// HEALTH
import NewHealth from "../containers/NewHealth";
import HealthAdminContainer from "../containers/HealthAdminContainer";

import MyDorm from "../containers/MyDorm";

// import Calendar, {ManageCalendarContainer} from '../containers/Calendar';
import Calendar from "../containers/Calendar";
import SettingsContainer from "../containers/SettingsContainer";

// import RosterContainer from '../containers/RosterContainer'
import NewRoster from "../containers/NewRoster";
// import RosterDetails, {RosterProfileContainer} from '../containers/RosterDetails'
import { RosterProfileContainer } from "../containers/RosterDetails";
import RosterEdit from "../containers/RosterEdit";
import ShareRoster from "../containers/ShareRoster";

import ManageCalendarNew from "../containers/ManageCalendar";

import SearchContainer from "../containers/SearchContainer";
import SearchFacultyContainer from "../containers/SearchFacultyContainer";
import CheckinContainer from "../containers/CheckinContainer";
import ProtectedRoute from "../protectedRoute";
import FacultyProfileContainer from "../containers/FacultyProfileContainer";

import Header from "../components/Header";

const Routing = ({ location, authUser, ...rest }) => (
  <BrowserRouter>
    <Header {...rest} />
    <Switch location={location}>
      <Route exact path="/app/" component={() => <Splash {...rest} />} />
      <Route
        exact
        path="/app/pw-forget"
        component={() => <PasswordForgetPage {...rest} />}
      />

      <ProtectedRoute
        path="/app/home"
        component={() => <HomeContainer {...rest} />}
      />

      <ProtectedRoute
        path="/app/posts/new"
        component={() => <NewPostsContainer {...rest} />}
      />
      <ProtectedRoute
        path="/app/posts/approve"
        component={() => <NewPostApprovalContainer {...rest} />}
      />
      <ProtectedRoute
        path="/app/posts/:post"
        component={() => <PostDetailsContainer {...rest} location={location} />}
      />
      <ProtectedRoute
        path="/app/posts"
        component={() => <MyPostsContainer {...rest} />}
      />

      <ProtectedRoute
        path="/app/chat/new"
        component={() => <NewChatContainer {...rest} />}
      />
      <ProtectedRoute
        path="/app/chat/:id"
        component={() => <ChatRoomContainer {...rest} />}
      />
      <ProtectedRoute
        path="/app/chat"
        component={() => <ChatContainer {...rest} />}
      />
      <ProtectedRoute
        path="/app/leaves/new"
        component={() => <NewLeave {...rest} />}
      />
      <ProtectedRoute
        path="/app/leaves/:leave"
        component={() => <LeaveDetails {...rest} />}
      />

      <ProtectedRoute
        path="/app/leaves"
        component={() => <AirportContainer {...rest} />}
      />

      <ProtectedRoute
        path="/app/health"
        component={() => <NewHealth {...rest} />}
      />

      <ProtectedRoute
        path="/app/health-admin"
        component={() => <HealthAdminContainer {...rest} />}
      />

      <ProtectedRoute path="/app/dorm" component={() => <MyDorm {...rest} />} />
      <ProtectedRoute
        path="/app/calendar/manage"
        component={() => <ManageCalendarNew {...rest} />}
      />

      <ProtectedRoute
        path="/app/calendar"
        component={() => <Calendar {...rest} />}
      />

      <ProtectedRoute
        path="/app/search-faculty"
        component={() => <SearchFacultyContainer {...rest} />}
      />
      
      <ProtectedRoute
        path="/app/settings"
        component={() => <SettingsContainer {...rest} />}
      />

      <ProtectedRoute
        path="/app/profile/:profile"
        component={() => <ProfileContainer {...rest} />}
      />
      <ProtectedRoute
        path="/app/faculty-profile/:profile"
        component={() => <FacultyProfileContainer {...rest} />}
      />

      <ProtectedRoute
        path="/app/profile"
        component={() => <MyProfile {...rest} />}
      />

      <ProtectedRoute
        path="/app/search"
        component={() => <SearchContainer {...rest} />}
      />
      <ProtectedRoute
        path="/app/roster/new"
        component={() => <NewRoster {...rest} />}
      />
      <ProtectedRoute
        path="/app/roster/:roster/edit"
        component={() => <RosterEdit {...rest} />}
      />
      <ProtectedRoute
        path="/app/roster/:roster/share"
        component={() => <ShareRoster {...rest} />}
      />
      {/* <ProtectedRoute path='/app/roster/:roster' component={() => <RosterDetails {...rest}/>}/> */}
      <ProtectedRoute
        path="/app/roster/:roster/:profile"
        component={() => <RosterProfileContainer {...rest} />}
      />
      {/* <ProtectedRoute path='/app/roster' component={() => <RosterContainer {...rest}/>}/> */}

      <ProtectedRoute
        path="/app/checkin"
        component={() => <CheckinContainer {...rest} />}
      />
      <Route path="/" component={() => <Redirect to={"/app"} />} />
    </Switch>
  </BrowserRouter>
);

export default Routing;
